var map = {
	"./AD.svg": 856,
	"./AE.svg": 857,
	"./AF.svg": 858,
	"./AG.svg": 859,
	"./AI.svg": 860,
	"./AL.svg": 861,
	"./AM.svg": 862,
	"./AN.svg": 863,
	"./AO.svg": 864,
	"./AQ.svg": 865,
	"./AR.svg": 866,
	"./AS.svg": 867,
	"./AT.svg": 868,
	"./AU.svg": 869,
	"./AW.svg": 870,
	"./AX.svg": 871,
	"./AZ.svg": 872,
	"./BA.svg": 873,
	"./BB.svg": 874,
	"./BD.svg": 875,
	"./BE.svg": 876,
	"./BF.svg": 877,
	"./BG.svg": 878,
	"./BH.svg": 879,
	"./BI.svg": 880,
	"./BJ.svg": 881,
	"./BL.svg": 882,
	"./BM.svg": 883,
	"./BN.svg": 884,
	"./BO.svg": 885,
	"./BR.svg": 886,
	"./BS.svg": 887,
	"./BT.svg": 888,
	"./BV.svg": 889,
	"./BW.svg": 890,
	"./BY.svg": 891,
	"./BZ.svg": 892,
	"./CA.svg": 893,
	"./CC.svg": 894,
	"./CD.svg": 895,
	"./CF.svg": 896,
	"./CG.svg": 897,
	"./CH.svg": 898,
	"./CI.svg": 899,
	"./CK.svg": 900,
	"./CL.svg": 901,
	"./CM.svg": 902,
	"./CN.svg": 903,
	"./CO.svg": 904,
	"./CR.svg": 905,
	"./CU.svg": 906,
	"./CV.svg": 907,
	"./CW.svg": 908,
	"./CX.svg": 909,
	"./CY.svg": 910,
	"./CZ.svg": 911,
	"./DE.svg": 912,
	"./DJ.svg": 913,
	"./DK.svg": 914,
	"./DM.svg": 915,
	"./DO.svg": 916,
	"./DZ.svg": 917,
	"./EC.svg": 918,
	"./EE.svg": 919,
	"./EG.svg": 920,
	"./ER.svg": 921,
	"./ES.svg": 922,
	"./ET.svg": 923,
	"./EU.svg": 924,
	"./FI.svg": 925,
	"./FJ.svg": 926,
	"./FK.svg": 927,
	"./FM.svg": 928,
	"./FO.svg": 929,
	"./FR.svg": 930,
	"./GA.svg": 931,
	"./GB-ENG.svg": 932,
	"./GB-NIR.svg": 933,
	"./GB-SCT.svg": 934,
	"./GB-WLS.svg": 935,
	"./GB-ZET.svg": 936,
	"./GB.svg": 937,
	"./GD.svg": 938,
	"./GE.svg": 939,
	"./GF.svg": 940,
	"./GG.svg": 941,
	"./GH.svg": 942,
	"./GI.svg": 943,
	"./GL.svg": 944,
	"./GM.svg": 945,
	"./GN.svg": 946,
	"./GP.svg": 947,
	"./GQ.svg": 948,
	"./GR.svg": 949,
	"./GS.svg": 950,
	"./GT.svg": 951,
	"./GU.svg": 952,
	"./GW.svg": 953,
	"./GY.svg": 954,
	"./HK.svg": 955,
	"./HM.svg": 956,
	"./HN.svg": 957,
	"./HR.svg": 958,
	"./HT.svg": 959,
	"./HU.svg": 960,
	"./ID.svg": 961,
	"./IE.svg": 962,
	"./IL.svg": 963,
	"./IM.svg": 964,
	"./IN.svg": 965,
	"./IO.svg": 966,
	"./IQ.svg": 967,
	"./IR.svg": 968,
	"./IS.svg": 969,
	"./IT.svg": 970,
	"./JE.svg": 971,
	"./JM.svg": 972,
	"./JO.svg": 973,
	"./JP.svg": 974,
	"./KE.svg": 975,
	"./KG.svg": 976,
	"./KH.svg": 977,
	"./KI.svg": 978,
	"./KM.svg": 979,
	"./KN.svg": 980,
	"./KP.svg": 981,
	"./KR.svg": 982,
	"./KW.svg": 983,
	"./KY.svg": 984,
	"./KZ.svg": 985,
	"./LA.svg": 986,
	"./LB.svg": 987,
	"./LC.svg": 988,
	"./LGBT.svg": 989,
	"./LI.svg": 990,
	"./LK.svg": 991,
	"./LR.svg": 992,
	"./LS.svg": 993,
	"./LT.svg": 994,
	"./LU.svg": 995,
	"./LV.svg": 996,
	"./LY.svg": 997,
	"./MA.svg": 998,
	"./MC.svg": 999,
	"./MD.svg": 1000,
	"./ME.svg": 1001,
	"./MF.svg": 1002,
	"./MG.svg": 1003,
	"./MH.svg": 1004,
	"./MK.svg": 1005,
	"./ML.svg": 1006,
	"./MM.svg": 1007,
	"./MN.svg": 1008,
	"./MO.svg": 1009,
	"./MP.svg": 1010,
	"./MQ.svg": 1011,
	"./MR.svg": 1012,
	"./MS.svg": 1013,
	"./MT.svg": 1014,
	"./MU.svg": 1015,
	"./MV.svg": 1016,
	"./MW.svg": 1017,
	"./MX.svg": 1018,
	"./MY.svg": 1019,
	"./MZ.svg": 1020,
	"./NA.svg": 1021,
	"./NC.svg": 1022,
	"./NE.svg": 1023,
	"./NF.svg": 1024,
	"./NG.svg": 1025,
	"./NI.svg": 1026,
	"./NL.svg": 1027,
	"./NO.svg": 1028,
	"./NP.svg": 1029,
	"./NR.svg": 1030,
	"./NU.svg": 1031,
	"./NZ.svg": 1032,
	"./OM.svg": 1033,
	"./PA.svg": 1034,
	"./PE.svg": 1035,
	"./PF.svg": 1036,
	"./PG.svg": 1037,
	"./PH.svg": 1038,
	"./PK.svg": 1039,
	"./PL.svg": 1040,
	"./PM.svg": 1041,
	"./PN.svg": 1042,
	"./PR.svg": 1043,
	"./PS.svg": 1044,
	"./PT.svg": 1045,
	"./PW.svg": 1046,
	"./PY.svg": 1047,
	"./QA.svg": 1048,
	"./RE.svg": 1049,
	"./RO.svg": 1050,
	"./RS.svg": 1051,
	"./RU.svg": 1052,
	"./RW.svg": 1053,
	"./SA.svg": 1054,
	"./SB.svg": 1055,
	"./SC.svg": 1056,
	"./SD.svg": 1057,
	"./SE.svg": 1058,
	"./SG.svg": 1059,
	"./SH.svg": 1060,
	"./SI.svg": 1061,
	"./SJ.svg": 1062,
	"./SK.svg": 1063,
	"./SL.svg": 1064,
	"./SM.svg": 1065,
	"./SN.svg": 1066,
	"./SO.svg": 1067,
	"./SR.svg": 1068,
	"./SS.svg": 1069,
	"./ST.svg": 1070,
	"./SV.svg": 1071,
	"./SX.svg": 1072,
	"./SY.svg": 1073,
	"./SZ.svg": 1074,
	"./TC.svg": 1075,
	"./TD.svg": 1076,
	"./TF.svg": 1077,
	"./TG.svg": 1078,
	"./TH.svg": 1079,
	"./TJ.svg": 1080,
	"./TK.svg": 1081,
	"./TL.svg": 1082,
	"./TM.svg": 1083,
	"./TN.svg": 1084,
	"./TO.svg": 1085,
	"./TR.svg": 1086,
	"./TT.svg": 1087,
	"./TV.svg": 1088,
	"./TW.svg": 1089,
	"./TZ.svg": 1090,
	"./UA.svg": 1091,
	"./UG.svg": 1092,
	"./UM.svg": 1093,
	"./US-CA.svg": 1094,
	"./US.svg": 1095,
	"./UY.svg": 1096,
	"./UZ.svg": 1097,
	"./VA.svg": 1098,
	"./VC.svg": 1099,
	"./VE.svg": 1100,
	"./VG.svg": 1101,
	"./VI.svg": 1102,
	"./VN.svg": 1103,
	"./VU.svg": 1104,
	"./WF.svg": 1105,
	"./WS.svg": 1106,
	"./XK.svg": 1107,
	"./YE.svg": 1108,
	"./YT.svg": 1109,
	"./ZA.svg": 1110,
	"./ZM.svg": 1111,
	"./ZW.svg": 1112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;